export const Survey = `
<ul>
    <li>球场模式：</li>
    <li>球场数据：</li>
    <li>建立时间：</li>
    <li>设  计 师：</li>
    <li>球场面积：</li>
    <li>球道长度：</li>
    <li>果岭草种：</li>
    <li>球道草种：</li>
</ul>`

export const ConstituteDesc = `
    <div id="xingchengjieshao" class="constitute-desc-title"><i class="iconfont">&#xe7f4;</i> 行程介绍</div>

    <div id="jiageshuoming" class="constitute-desc-title"><i class="iconfont">&#xe64a;</i> 价格说明</div>

    <div id="yudingliucheng" class="constitute-desc-title"><i class="iconfont">&#xe623;</i> 预订流程</div>

    <div id="yudingxuzhi" class="constitute-desc-title"><i class="iconfont">&#xe63e;</i> 预订须知</div>
`